import {
  Box,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Typography,
} from '@mui/material';
import {
  deleteFile,
  getPersonalDetail,
  IWaiverOfMedicalConfidentiality,
  postFile,
} from 'API';

import { Dictionary } from 'Dictionary';
import { DICTIONARY, FileCategories } from 'Enum';
import { Controller, useFormContext } from 'react-hook-form';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { useEffect, useState } from 'react';
import { useAppSelector, useDictionary, useIsDesktop } from 'Hooks';
import { requiredMessage } from 'Regex';
export const FirstSection = () => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext<IWaiverOfMedicalConfidentiality>();

  const [personalDetails, setPersonalDetails] = useState<{
    firstName?: string;
    lastName?: string;
    identifier?: string;
  } | null>(null);

  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.WAIVER_OF_MEDICAL_CONFIDENTIALITY
  );

  const { isConfirm } = watch();
  const { files, status } = useAppSelector(({ file: { files, status } }) => ({
    files: files[FileCategories.MedicalConfidentialityWaiver],
    status,
  }));
  const generatePdf = async () => {
    if (status === 'FINISHED_SETTING') {
      if (isConfirm) {
        if (files) return;
        const pdfElement = document.getElementById('pdf');
        if (pdfElement) {
          const a = await html2canvas(pdfElement);
          var pdf = new jsPDF();
          const dataUrl = await a.toDataURL('image/png');
          pdf.addImage(dataUrl, 'PNG', 0, 0, 200, 250);
          const arrayBuffer = pdf.output('arraybuffer');
          const file = new File([arrayBuffer], 'waiver.pdf', {
            type: 'application/pdf',
          });
          const form = new FormData();
          form.append('file', file);
          await postFile(FileCategories.MedicalConfidentialityWaiver, form);
        }
      } else {
        if (files) {
          await deleteFile(files[0].id);
        }
      }
    }
  };

  // If uncomment this lines, it create and send to server pdf
  // useEffect(() => {
  //   generatePdf();
  // }, [isConfirm, files]);

  const setPersonalFiles = async () => {
    const personalDetails = await getPersonalDetail();
    if (personalDetails) {
      setPersonalDetails({
        firstName: personalDetails.personalInfoSection?.firstName || '',
        lastName: personalDetails.personalInfoSection?.lastName || '',
        identifier: personalDetails.personalInfoSection?.israeliId || '',
      });
    }
  };
  useEffect(() => {
    setPersonalFiles();
  }, []);

  return (
    <Box id='pdf'>
      <Typography sx={{ mt: isDesktop ? 4 : undefined }}>
        {dictionary.firstSectionFirstParagraph[0]}
        <strong>{`${personalDetails?.firstName} ${personalDetails?.lastName}`}</strong>
        {dictionary.firstSectionFirstParagraph[1]}
      </Typography>
      <Typography sx={{ mt: 2 }}>
        {dictionary.firstSectionSecondParagraph}
      </Typography>
      <Typography sx={{ mt: 2 }}>
        {dictionary.firstSectionThirdParagraph}
      </Typography>
      <Typography sx={{ mt: 2 }}>
        {dictionary.firstSectionFourthParagraph}
      </Typography>

      <Typography sx={{ mt: 2 }}>{dictionary.firstSectionFivthP}</Typography>
      <Typography sx={{ mt: 2 }}>{dictionary.firstSectionSixthP}</Typography>
      <Typography sx={{ mt: 2 }}>{dictionary.firstSectionSeventhP}</Typography>

      <Controller
        render={({ field: { value, ...rest } }) => (
          <FormControlLabel
            sx={{ alignItems: 'flex-start', mt: 5 }}
            control={
              <Checkbox
                checked={value}
                {...rest}
                sx={{
                  width: 0,
                  height: 0,
                  p: '0 20px',
                  mt: '12px',
                }}
              />
            }
            label={
              <Typography>
                {Dictionary[
                  DICTIONARY.WAIVER_OF_MEDICAL_CONFIDENTIALITY
                ].firstSectionCheckboxLabel(
                  personalDetails?.firstName,
                  personalDetails?.lastName,
                  personalDetails?.identifier
                )}
              </Typography>
            }
          />
        )}
        rules={{
          required: {
            message: requiredMessage,
            value: true,
          },
        }}
        name='isConfirm'
        control={control}
      />
      {errors.isConfirm && (
        <FormHelperText color='error'>
          <Typography color='error'>{requiredMessage}</Typography>
        </FormHelperText>
      )}
    </Box>
  );
};
